<skitbs-template [title]="v('menu_profile')">

    <form #formEdit="ngForm">
        <div *ngIf="modelXBVO != null">

            <!-- I. Contract partner  -->
            <p-panel styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-user MarH"></i><b>{{ v('profile_address') }}</b>
                </ng-template>

                <div class="d-table">
                    <div>
                        <div class="BsWid60p">{{ v('cpNr') }}</div>
                        <div class="Wid100 FontBold Green">{{ modelXBVO.cpNr }}</div>
                    </div>
                    <div>
                        <div>{{ v('cp') }}</div>
                        <div>{{ modelXBVO.cpName }}</div>
                    </div>
                    <div>
                        <div>{{ v('street') }}</div>
                        <div class="p-input-filled">
                            <input type="text" pInputText [(ngModel)]="modelXBVO.cpAddr.streetName" class="BsWid140p" required maxlength="60" name="cpStreetName">
                            <input type="text" pInputText [(ngModel)]="modelXBVO.cpAddr.streetNr" class="BsWid40p" required maxlength="10" name="cpStreetNr" style="margin-left: 1px;">
                        </div>
                    </div>
                    <div>
                        <div>{{ v('addrLocation') }}</div>
                        <div class="p-input-filled">
                            <input type="text" pInputText [(ngModel)]="modelXBVO.cpAddr.zip" class="BsWid50p" required name="cpZip" pattern="[0-9]{4,5}" maxlength="5">
                            <input type="text" pInputText [(ngModel)]="modelXBVO.cpAddr.city" class="BsWid120p MarL" required maxlength="60" name="cpCity">
                            <div *ngIf="editForm.form.get('cpZip')?.invalid && editForm.form.get('cpZip')?.touched" class="Red">{{v('validation.zip.message')}}</div>
                        </div>
                    </div>
                    <div>
                        <div>{{ v('phone') }}</div>
                        <div class="p-input-filled">
                            <input type="text" pInputText [(ngModel)]="modelXBVO.cpAddr.phoneArea" class="BsWid40p" name="cpArea" pattern="\+?[0-9]{2,6}" maxlength="7">
                            <input type="text" pInputText [(ngModel)]="modelXBVO.cpAddr.phoneNr" class="BsWid100p MarL" name="cpPhoneNr" pattern="[0-9]{3,15}" maxlength="15">
                            <div *ngIf="editForm.form.get('cpArea')?.invalid && editForm.form.get('cpArea')?.touched" class="Red">{{v('validation.phonearea.format.message')}}</div>
                            <div *ngIf="editForm.form.get('cpPhoneNr')?.invalid && editForm.form.get('cpPhoneNr')?.touched" class="Red">{{v('validation.phone.format.message')}}</div>
                        </div>
                    </div>
                    <div>
                        <div>{{ v('phoneMobile') }}</div>
                        <div class="p-input-filled">
                            <input type="text" pInputText [(ngModel)]="modelXBVO.cpAddr.phoneMobile" class="BsWid140p" name="cpMobile" disabled>
                        </div>
                    </div>
                    <div>
                        <div>E-Mail</div>
                        <div class="p-input-filled">
                            <input type="text" pInputText [(ngModel)]="modelXBVO.cpAddr.email" name="cpEmail"
                                   class="Wid100" style="max-width: 260px;" maxlength="255"
                                   required pattern="[\w\-\.]+@([\w\-]+\.)+[\w\-]{2,8}"
                            >
                            <div *ngIf="editForm.form.get('cpEmail')?.invalid && editForm.form.get('cpEmail')?.touched" class="Red">{{v('validation.email.format.message')}}</div>
                        </div>
                    </div>
                    <div>
                        <div>{{ v('contractStart') }}</div>
                        <div>{{ dateFormat(modelXBVO.tgContractStart) }}</div>
                    </div>
                    <div>
                        <div>{{ v('contract') }}</div>
                        <div>
                            <button pButton label="{{v('catering_contract')}}" (click)="onDownloadContract()" iconPos="left" icon="pi pi-print" class="MarT"></button>
                        </div>
                    </div>
                </div>

            </p-panel>
            <div class="EmptyBox30"></div>

            <!-- IV. Tableguest   -->
            <p-panel styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-user MarH"></i><b>{{ v('profile_tg') }}</b>
                </ng-template>

                <div class="d-table">
                    <div>
                        <div class="BsWid80p">{{ v('name') }}</div>
                        <div>{{ modelXBVO.tgName }}</div>
                    </div>
                    <div>
                        <div class="BsWid80p">{{ v('birthdate') }}</div>
                        <div class="p-input-filled">
                            <p-calendar
                                [(ngModel)]="modelXBVO.tgBirthday" name="tgBirthday" [maxDate]="getYesterday()" dateFormat="dd.mm.yy" styleClass="BsDate"
                                [required]="true" name="tgBirthday" validateBirthday="bob" [readonlyInput]="true">
                            </p-calendar>
                            <div *ngIf="editForm.form.get('tgBirthday')?.invalid && editForm.form.get('tgBirthday')?.touched" class="Red">{{v('invalidBirthday')}}</div>
                        </div>
                    </div>
                    <div>
                        <div class="BsWid80p">{{ v('facility') }}</div>
                        <div class="p-input-filled">{{ modelXBVO.faObjectName }}, {{ modelXBVO.faObjectNr }}</div>
                    </div>
                    <div>
                        <div class="BsWid80p">{{ v('groupClass') }}</div>
                        <div class="p-input-filled">{{ modelXBVO.grName }}</div>
                    </div>
                </div>
            </p-panel>
            <div class="EmptyBox30"></div>

            <!-- V. Contract Vorkasse  -->
            <p-panel styleClass="MarV" *ngIf="false">
                <ng-template pTemplate="header">
                    <i class="pi pi-wallet BsFsSmall MarH"></i><b>{{ v('menu_prepaid') }}</b>
                </ng-template>
                <div *ngIf="!modelXBVO.sepaIBAN">
                    {{ v('Ihr verfügbares Guthaben beträgt E 4.0000000') }}<br/>
                    <button pButton label="{{v('Zum Konto-Aufladen')}}" (click)="onDownloadSepa()" iconPos="left" icon="pi pi-plus-circle" class="MarT GreenBack"></button>
                </div>
            </p-panel>
            <div class="EmptyBox30"></div>

            <!-- V. Contract SEPA  -->
            <p-panel *ngIf="modelXBVO.sepaEnabled" styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-euro BsFsSmall MarH"></i><b>{{ v('profile_sepa') }}</b>
                </ng-template>

                <div class="d-table">
                    <div>
                        <div>{{ v('bankCountry') }}</div>
                        <div class="p-input-filled">
                            <p-dropdown
                                    [options]="selectItemsState.ibanCountries"
                                    [(ngModel)]="modelIbanCOUNTRY"
                                    name="modelIbanCOUNTRY"
                                    (onChange)="onBankDataChanged($event)">
                            </p-dropdown>
                        </div>
                    </div>
                    <div>
                        <div>IBAN</div>
                        <div class="p-input-filled">
                            <input pInputText [(ngModel)]="modelIbanNR" name="modelIbanNR"
                                   [required]="modelXBVO.sepaActive" #_ibanNr="ngModel" [ngModelOptions]="{updateOn: 'blur'}"
                                   (ngModelChange)="onIbanChanged(_ibanNr)" style="width: 185px;" maxLength="26"
                                   (focus)="onIbanFocus(_ibanNr)" (focusout)="onIbanFocusOut(_ibanNr)"> <br/>

                            <div *ngIf="_ibanNr?.errors?.['ibanValidatorMessage']" class="Red" [title]="_ibanNr.errors['ibanValidatorDetails']">{{ _ibanNr.errors['ibanValidatorMessage'] }}</div>
                        </div>
                    </div>
                    <div>
                        <div>{{ v('bankInstitution') }}</div>
                        <div class="p-input-filled">
                            <input pInputText
                                   [(ngModel)]="modelXBVO.sepaInstitut"
                                   name="sepaInstitut"
                                   [required]="modelXBVO.sepaActive"
                                   maxLength="26"
                                   (ngModelChange)="onBankDataChanged()">
                        </div>
                    </div>
                    <div *ngIf="modelIbanCOUNTRY !== 'DE'">
                        <div>BIC</div>
                        <div class="p-input-filled">
                            <input pInputText [(ngModel)]="modelBicNR" name="modelBicNR"
                                   [required]="false" #_bicNr="ngModel"
                                   (ngModelChange)="onBicChanged(_bicNr)">

                                   <div *ngIf="_bicNr?.errors?.['bicValidatorMessage']" class="Red" [title]="_bicNr.errors['bicValidatorDetails']">{{ _bicNr.errors['bicValidatorMessage'] }}</div>
                            <br/>
                        </div>
                    </div>
                    <div>
                        <div style="background: transparent"></div>
                        <div class="p-input-filled">
                            <a [routerLink]="" (click)="onTakeoverAccountOwner()">
                                <span class="BoldGray FontBold"> <i class="fas fa-download"></i> {{ v('accountHolderIsOwner') }}</span>
                            </a>
                        </div>
                    </div>
                    <div>
                        <div>{{ v('accountHolder') }}</div>
                        <div class="p-input-filled">
                            <input pInputText
                                   [(ngModel)]="modelXBVO.sepaAccountOwner"
                                   name="sepaAccountOwner"
                                   [required]="modelXBVO.sepaActive"
                                   maxLength="100"
                                   (ngModelChange)="onBankDataChanged()"
                                   #_ao="ngModel"
                                   pattern="[a-zA-Z0-9\/\?:\(\)\.\,'\+\- ]{0,140}">
                        </div>
                        <div *ngIf="_ao?.errors" class="Red">{{ v('accountOwnerWrongFormat') }}</div>
                    </div>
                    <div>
                        <div>{{ v('accountHolder') }} {{ v('address') }}</div>
                        <div class="p-input-filled">
                            <input pInputText [(ngModel)]="modelXBVO.sepaAccountOwnerAddr" name="sepaAccountOwnerAddr" [required]="false" maxLength="100">
                        </div>
                    </div>
                    <!--
                                        <div>
                                            <div>SEPA</div>
                                            <div >
                                                <button pButton label="{{v('sepa')}}" (click)="onDownloadSepa()" iconPos="left" icon="pi pi-print" class="MarT"></button>
                                            </div>
                                        </div>
                    -->
                    <div *ngIf="modelXBVO.sepaChanged">
                        <div>
                            <input type="checkbox" [(ngModel)]="modelConfirmedSepa" name="sepaActive"/>
                        </div>
                        <div>
                            {{ vp('confirmation_agb_1', ['TENANT_NAME'|env]) }}
                            <div *ngIf="!modelConfirmedSepa && modelXBVO.sepaChanged" class="Red">{{ v('confirmSepa') }}</div>
                        </div>
                    </div>
                </div>
            </p-panel>
            <div class="EmptyBox30"></div>

            <!-- VI. Contract RFID  -->
            <p-panel styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-id-card MarH"></i><b>{{ v('profile_rfid') }}</b>
                </ng-template>


                <div class="d-table" *ngIf="modelXBVO.rfidNNr!=null || modelXBVO.rfidBarcode!=null || modelXBVO.rfidCreated!=null || modelXBVO.rfidNr !=null; else noChipcard">
                    <div>
                        <div class="BsWid80p">Serie/Nr.</div>
                        <div>{{ modelXBVO.rfidSeries }} {{ modelXBVO.rfidNr }}</div>
                    </div>
                    <div>
                        <div class="BsWid80p">{{ v('created') }}</div>
                        <div>{{ dateFormat(modelXBVO.rfidCreated) }}</div>
                    </div>
                    <div>
                        <div class="BsWid80p">{{ v('duplicate') }}</div>
                        <div>{{ modelXBVO.rfidNNr }}</div>
                    </div>
                </div>
                <ng-template #noChipcard>{{ v('chip_inactive') }}</ng-template>
            </p-panel>
            <div class="EmptyBox30"></div>

            <!-- II. Cafeteria  -->
            <p-panel *ngIf="modelXBVO.cafeteria" styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-wallet MarH"></i><b>{{ v('profile_cafeteria') }}</b>
                </ng-template>

                <div class="d-table">
                    <div>
                        <div class="BsWid160p">
                            <label>{{ v('cafeteria_from') }}</label>
                        </div>
                        <div>
                            <p-calendar [(ngModel)]="modelXBVO.cafeteriaFrom" name="cafeteriaFrom" [minDate]="getToday()" dateFormat="dd.mm.yy" styleClass="BsDate"
                                        inputStyleClass="{{modelXBVO.cafeteriaFrom != null ? '' : ''}}"></p-calendar>
                        </div>
                    </div>
                    <div class="PadT">
                        <div>
                            <label>{{ v('cafeteria_lockfrom') }}</label>
                        </div>
                        <div>
                            <p-calendar [(ngModel)]="modelXBVO.cafeteriaLockFrom" name="cafeteriaLockFrom" [minDate]="getToday()" dateFormat="dd.mm.yy" styleClass="BsDate"
                                        inputStyleClass="{{modelXBVO.cafeteriaLockFrom != null ? 'SoftRedBack' : ''}}"></p-calendar>
                            <div class="EmptyBox5"></div>
                        </div>
                    </div>
                </div>
                <div class="PadAll">{{ modelXBVO.sepaIBAN != null ? v('cafeteria_remarks1') : v('cafeteria_remarks2') }}</div>
            </p-panel>
            <div class="EmptyBox30"></div>

            <!-- I. Standing orders -->
            <p-panel styleClass="MarB">
                <ng-template pTemplate="header">
                    <i class="pi pi-calendar-plus MarH"></i><b>{{ v('standingOrders') }}</b>
                </ng-template>

                <div *ngIf="modelXBVO.standingOrdersInfo != null; else noStandingOrders" innerHTML="{{modelXBVO.standingOrdersInfo}}"></div>
                <ng-template #noStandingOrders>{{ v('so_inactive') }}</ng-template>
            </p-panel>
            <div class="EmptyBox30"></div>

            <!-- Notification config  -->
            <p-panel styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-cog BsFsSmall MarH"></i><b>{{ v('notifications') }}</b>
                </ng-template>
                <span [title]="modelXBVO.notifyPlanChangedLast!=null ? (modelXBVO.notifyPlanChangedLast | date: 'dd-MM-yyyy HH:mm') : ''">
                    <p-checkbox [(ngModel)]="modelXBVO.notifyPlanChangedActive" [binary]="true" [label]="v('config_menuplan_changed')" name="_notifyPlanChangedActive"></p-checkbox>
                </span>
            </p-panel>
            <div class="EmptyBox30"></div>

            <!-- II. Password change   -->
            <p-panel styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-key MarH"></i><b>{{ v('change_password') }}</b>
                </ng-template>
                <label class="BsFsSmall Gray">{{ v('old_password') }}</label><br/>
                <div class="d-flex MarT">
                    <div>
                        <p-password [(ngModel)]="modelOldPassword" name="pwdo" #pwdo="ngModel" inputStyleClass="BsWid80p" [feedback]="false"></p-password>
                    </div>
                </div>
                <label class="BsFsSmall Gray">{{ v('new_password') }}</label><br/>
                <div class="d-flex MarT">
                    <div>
                        <p-password [(ngModel)]="modelNewPassword" name="pwd" #pwd="ngModel" minlength="8" inputStyleClass="BsWid80p" [feedback]="false"></p-password>
                    </div>
                    <div>
                        <p-password [(ngModel)]="modelNewPasswordConfirmation" name="pwdr" #pwdr="ngModel" minlength="8" inputStyleClass="BsWid80p" class="MarL"
                                    [feedback]="false"></p-password>
                    </div>
                    <button pButton (click)="onChangePassword()" icon="pi pi-save" [disabled]="pwdo.model==null || pwd.model==null || pwdr.model==null || pwd.invalid || pwdr.invalid" class="MarL"></button>
                </div>
                <br />
                <label class="BsFsSmall Gray">{{ v('pwRules') }}</label><br/>
                <label class="BsFsSmall Gray">- {{ v('pwRulesLength') }}</label><br/>
                <label class="BsFsSmall Gray">- {{ v('pwRules1UpperCase') }}</label><br/>
                <label class="BsFsSmall Gray">- {{ v('pwRules1LowerCase') }}</label><br/>
                <label class="BsFsSmall Gray">- {{ v('pwRules1Digit') }}</label><br/>
                <label class="BsFsSmall Gray">- {{ v('pwRules1SpecialCharacter') }}</label><br/><br/>
                <label class="BsFsSmall Gray">{{ v('pwRulesNotAllowedCharacters') }}</label><br/>
            </p-panel>


            <div class="EmptyBox20"></div>
            <div class="TexAlCenter">
                <button pButton label="{{v('save_profile')}}" (click)="onSave()" iconPos="left" icon="pi pi-save" class="BsWid200p PadWithBorder10" [disabled]="!canSave()"></button>
            </div>
            <div class="EmptyBox40"></div>
        </div>
    </form>
</skitbs-template>
